import React from 'react';
import {useNavigate} from 'react-router-dom';
import {SparklesIcon} from "../components/icons";
import WardrobeStats from "../components/WardrobeStats";
import HomeOutfitCard from "../components/HomeOutfitCard";
import HomeAutopilotCard from "../components/HomeAutopilotCard";
import WardrobeHealthCard from "../components/WardrobeHealthCard";
import RediscoverCard from "../components/RediscoverCard";
import OnboardingResumeBanner from "../components/onboarding/OnboardingResumeBanner";
import TodayEventsBlock from "../components/TodayEventsBlock";
import {useDocumentTitle} from '../hooks/useDocumentTitle';

interface QuickAction {
    label: string;
    route: string;
    primary?: boolean;
    icon?: React.ReactNode;
}

const QUICK_ACTIONS: QuickAction[] = [
    {label: 'Оценить образ', route: '/outfit-evaluation', primary: true, icon: <SparklesIcon className="w-4 h-4"/>},
    {label: 'Образ дня', route: '/outfit'},
    {label: 'Распознать вещь', route: '/ai-recognition'},
];

const Home: React.FC = () => {
    const navigate = useNavigate();

    useDocumentTitle();

    const today = new Date().toLocaleDateString('ru-RU', {weekday: 'long', day: 'numeric', month: 'long'});

    return (
        <div className="space-y-6">
            {/* Прерванный мастер онбординга: предложение продолжить (первый вход уводит в мастер) */}
            <OnboardingResumeBanner/>

            {/* Шапка: дата + быстрые действия (одна primary на регион) */}
            <header className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Главная</h1>
                    <p className="text-sm text-gray-500 dark:text-gray-400 first-letter:uppercase">{today}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                    {QUICK_ACTIONS.map(a => (
                        <button
                            key={a.route}
                            type="button"
                            onClick={() => navigate(a.route)}
                            className={`min-h-[44px] inline-flex items-center gap-2 px-4 rounded-xl text-sm font-semibold transition ${
                                a.primary
                                    ? 'bg-brand-500 hover:bg-brand-600 text-white'
                                    : 'border border-gray-200 dark:border-white/10 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-white/5'
                            }`}
                        >
                            {a.icon}{a.label}
                        </button>
                    ))}
                </div>
            </header>

            {/* KPI-ряд: состояние гардероба за 5 секунд (above the fold) */}
            <WardrobeStats/>

            {/* Доминантный фид: образ дня */}
            <HomeOutfitCard/>

            {/* Контекст дня из календаря: подо что сегодня одеваться (CTHS-175).
                Блок сам решает, показываться ли: не подключено / выключено — не рендерится. */}
            <TodayEventsBlock/>

            {/* Supporting-блоки: на десктопе в две колонки, чтобы не растягивать страницу */}
            <div className="grid gap-6 lg:grid-cols-2 items-start">
                <HomeAutopilotCard/>
                <WardrobeHealthCard/>
            </div>

            <RediscoverCard/>
        </div>
    );
};

export default Home;
